import { render, staticRenderFns } from "./PageNews.vue?vue&type=template&id=723693b1&"
import script from "./PageNews.vue?vue&type=script&lang=js&"
export * from "./PageNews.vue?vue&type=script&lang=js&"
import style0 from "./PageNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports